import React, { ComponentType, PropsWithChildren } from 'react';

interface PortalAvailabilityProps {
  isPreview: boolean;
  enabled: boolean;
}

export const withPortalAvailability =
  <P extends object>(Component: ComponentType<P>) =>
  (props: PropsWithChildren<P & PortalAvailabilityProps>) => {
    const { isPreview, enabled, children, ...restProps } = props;

    if (!enabled) return null;

    return <Component {...(restProps as P)}>{children}</Component>;
  };
